(function () {
  function init(root) {
    root.querySelectorAll('[data-az-native-filters]').forEach(function (component) {
      if (component.dataset.ready) return;
      const dialog = component.querySelector('dialog');
      const trigger = component.querySelector('[data-az-filter-open]');
      if (!dialog || !trigger) return;
      component.dataset.ready = 'true';
      const currentUrl = new URL(window.location.href);
      const preservedView = {
        grid_list: ['grid-view', 'list-view'],
        view: ['view-24', 'view-36', 'view-48']
      };
      Object.keys(preservedView).forEach(function (key) {
        const value = currentUrl.searchParams.get(key);
        if (!preservedView[key].includes(value)) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        component.querySelector('form').appendChild(input);
        component.querySelectorAll('.az-filter-chips a, .az-filter-actions a').forEach(function (link) {
          const url = new URL(link.href, window.location.href);
          url.searchParams.set(key, value);
          link.setAttribute('href', url.pathname + url.search + url.hash);
        });
      });
      const collectionRoot = component.closest('.az-native-pilot');
      if (collectionRoot) {
        collectionRoot.querySelectorAll('[data-collection-grid-view], [data-collection-list-view]').forEach(function (button) {
          const list = button.hasAttribute('data-collection-list-view');
          button.setAttribute('aria-pressed', String(list === (currentUrl.searchParams.get('grid_list') === 'list-view')));
        });
      }
      const mobile = window.matchMedia('(max-width: 719px)');
      function sync() {
        if (dialog.open && dialog.matches(':modal')) dialog.close();
        if (mobile.matches) dialog.removeAttribute('open');
        else dialog.setAttribute('open', '');
        trigger.hidden = !mobile.matches;
        trigger.setAttribute('aria-expanded', 'false');
      }
      trigger.addEventListener('click', function () {
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        dialog.querySelector('[data-az-filter-close]').focus();
      });
      dialog.querySelector('[data-az-filter-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('close', function () {
        trigger.setAttribute('aria-expanded', 'false');
        if (mobile.matches) trigger.focus();
      });
      component.querySelector('form').addEventListener('submit', function (event) {
        const min = component.querySelector('#az-price-min');
        const max = component.querySelector('#az-price-max');
        if (min && max && min.value && max.value && Number(min.value) > Number(max.value)) {
          min.setCustomValidity(min.dataset.rangeError || '');
          if (!min.validationMessage) min.setCustomValidity(max.labels[0].textContent.trim());
          min.reportValidity();
          event.preventDefault();
          return;
        }

      });
      component.querySelector('form').addEventListener('formdata', function (event) {
        component.querySelectorAll('input[type="number"]').forEach(function (input) {
          if (input.value === '') event.formData.delete(input.name);
        });
      });
      component.querySelectorAll('input[type="number"]').forEach(function (input) { input.addEventListener('input', function () { component.querySelectorAll('input[type="number"]').forEach(function (field) { field.setCustomValidity(''); }); }); });
      mobile.addEventListener('change', sync);
      sync();
    });
  }
  document.addEventListener('click', function (event) {
    const control = event.target.closest('[data-collection-grid-view], [data-collection-list-view], [data-az-page-size]');
    if (!control || !control.closest('.az-native-pilot')) return;
    const url = new URL(window.location.href);
    const pageSize = control.getAttribute('data-az-page-size');
    if (pageSize) {
      if (!['view-24', 'view-36', 'view-48'].includes(pageSize)) return;
      url.searchParams.set('view', pageSize);
    } else {
      url.searchParams.set('grid_list', control.hasAttribute('data-collection-list-view') ? 'list-view' : 'grid-view');
    }
    url.searchParams.delete('page');
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(url.pathname + url.search + url.hash);
  }, true);
  document.addEventListener('change', function (event) {
    const select = event.target.closest('[data-az-sort]');
    if (!select) return;
    event.stopImmediatePropagation();
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.assign(url.pathname + url.search + url.hash);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
